import { render } from "./FacebookSharing.vue?vue&type=template&id=360b0fe3"
import script from "./FacebookSharing.vue?vue&type=script&lang=ts"
export * from "./FacebookSharing.vue?vue&type=script&lang=ts"
script.render = render

export default script